/* Macht Glas-Kachel-Raster mit 5+ Kacheln zum Scroll-Snap-Slider und
   haengt Pfeil-Navigation UNTER die Kacheln (statt ueberlagernd). */
(function () {
  document.querySelectorAll('.eg-glass-tiles__grid').forEach(function (grid) {
    var tiles = grid.querySelectorAll('.eg-glass-tile');
    if (tiles.length < 5) return;
    grid.classList.add('eg-glass-slider');
    var nav = document.createElement('div');
    nav.className = 'eg-glass-nav';
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.setAttribute('aria-label', 'Vorherige Kacheln');
    prev.textContent = '←';
    var next = document.createElement('button');
    next.type = 'button';
    next.setAttribute('aria-label', 'Naechste Kacheln');
    next.textContent = '→';
    nav.appendChild(prev);
    nav.appendChild(next);
    grid.parentNode.insertBefore(nav, grid.nextSibling);
    function step() {
      var t = tiles[0].getBoundingClientRect().width;
      return t + parseFloat(getComputedStyle(grid).columnGap || 18);
    }
    prev.addEventListener('click', function () { grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { grid.scrollBy({ left: step(), behavior: 'smooth' }); });
  });
})();
